import {v4 as uuidv4} from 'uuid';
import {BlockType} from '../block';
import LinkBlock = App.Entities.Tasks.Ui.LinkBlock;

export const link: BlockType<LinkBlock> = {
  translationKey: 'link',
  icon: 'link',
  getName: (block) => block.text || block.href,
  providesAiContext: false,
  uiConfigFactory: () => ({
    uuid: uuidv4(),
    type: 'Link',
    name: 'Link',
    text: '',
    href: '',
    part: null,
  }),
  componentGraderFactory: null,
};
